import { t } from '../../../strings/i18n';
import { required } from '../../../xform';
export const LAST_NAME_INPUT_NAME = 'lastName';
const lastNameConfig = () => [
    LAST_NAME_INPUT_NAME,
    undefined,
    'ENABLED',
    [required(t('errors.lastNameRequired'))]
];
export default lastNameConfig;
